import { useQuery } from '@tanstack/react-query';
import apiClient from '../lib/api-client';

const useGetInvestmentReport = (policyNumber, enabled, basePath = 'life') => {
  return useQuery({
    queryKey: ['investmentReport', policyNumber],
    queryFn: async () => {
      const response = await apiClient.get(`/${basePath}/investment-report`, {
        params: { policy_number: policyNumber },
      });
      return response.data;
    },
    enabled: enabled && !!policyNumber,
  });
};

export { useGetInvestmentReport };